import { AccountInfo } from '@azure/msal-browser';
import { getAccount, setCurrentUsername, userAgentApplication } from './auth/service';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from './store';
import * as ApplicationStore from './store/Application';
import * as AuthStore from './store/Auth';
import SplashScreen from './SplashScreen';
import { Unauthorized } from './Unauthorized';

let account: AccountInfo | null;

const ApplicationStartup = (props: { children: React.ReactNode }): any => {
	const dispatch = useAppDispatch();

	useEffect(() => {
		userAgentApplication.initialize()
			.then(() => userAgentApplication.handleRedirectPromise())
			.then(response => {
				if (response) {
					account = response.account;
					const username = account ? account.username : null;
					setCurrentUsername(username);
				} else {
					account = getAccount();
				}

				if (account) {
					dispatch(ApplicationStore.actionCreators.start(account));
				} else {
					dispatch(AuthStore.actionCreators.login());
				}
			})
			.catch(error => {
				console.log(error);
                dispatch(AuthStore.actionCreators.loginFailed(error));
			});
	}, [dispatch]);

	const initialized = useSelector(ApplicationStore.selectors.getInitialized);
	const authError = useSelector(AuthStore.selectors.getError);

	if (authError) {
		return <Unauthorized />;
	}

	if (initialized.is === true) {
		return <SplashScreen />;
	}

	return props.children;
};
export default ApplicationStartup;
